import "../styles/WorkInProgress.css";

const WorkInProgress = () => {
    return (
        <div className='work-in-progress-content'>
            <h1 className="work-in-progress-text">This Page is Work in Progress</h1>
        </div>
    );
}

export default WorkInProgress;